export { default } from './clear-pill';
